'use client';

import { useEffect, useRef, useState } from 'react';
import style from './style.module.css';
import Loading from '../Loading';
import {
  useRouter,
  redirect as nextRedirect,
  RedirectType,
} from 'next/navigation';

interface ButtonWithLoadingProps {
  labelButtonSend: string;
  labelButtonRedirect: string;
  formDataIsValid: boolean;
  redirect: {
    url: string;
    isAllowed: boolean;
  };
}

const ButtonWithLoading = ({
  labelButtonSend,
  labelButtonRedirect,
  redirect,
  formDataIsValid,
}: ButtonWithLoadingProps) => {
  const [animationCompleted, setAnimationCompleted] = useState<boolean>(false);
  const saveButtonRef = useRef<HTMLButtonElement>(null);
  const loadingBarRef = useRef<HTMLDivElement>(null);
  const textNo1Ref = useRef<HTMLSpanElement>(null);
  const textNo2Ref = useRef<HTMLSpanElement>(null);
  const textNo3Ref = useRef<HTMLSpanElement>(null);
  const router = useRouter();

  useEffect(() => {
    if (animationCompleted && redirect.isAllowed) {
      window.location.href = redirect.url;
    }
  }, [animationCompleted, redirect.isAllowed, redirect.url]);

  const handleClick = () => {
    if (
      loadingBarRef.current &&
      textNo1Ref.current &&
      textNo2Ref.current &&
      textNo3Ref.current
    ) {
      loadingBarRef.current.classList.add(style.loadingBarAnim);
      textNo1Ref.current.style.opacity = '1';
      textNo3Ref.current.style.opacity = '0';
      textNo1Ref.current.classList.add(style.textAnim1);
      textNo2Ref.current.classList.add(style.textAnim2);
      textNo3Ref.current.classList.add(style.textAnim3);

      setTimeout(() => {
        loadingBarRef.current.classList.remove(style.loadingBarAnim);
        loadingBarRef.current.style.width = '100%';
        setAnimationCompleted(true);
      }, 3000);
    }
  };

  return (
    <button
      type="submit"
      disabled={!formDataIsValid}
      ref={saveButtonRef}
      className={style.saveButton}
      onClick={handleClick}>
      <div className={style.text}>
        <span ref={textNo1Ref} className={style.no1}>
          {labelButtonSend}
        </span>
        <span ref={textNo2Ref} className={style.no2}>
          <Loading />
        </span>
        <span ref={textNo3Ref} className={style.no3}>
          {labelButtonRedirect}
        </span>
      </div>
      <div ref={loadingBarRef} className={style.loadingBar}></div>
    </button>
  );
};

export default ButtonWithLoading;
